/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-table"]';

/**
 * Friendation component
 */
export const blockTable = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const table: HTMLTableElement = component.querySelector('table');
    table.addEventListener('click', () => {
      table.scrollIntoView({
        block: 'center'
      });
    });
  });
};
